import { HttpErrorResponse } from '@angular/common/http';
import { catchError, map, Observable, throwError } from 'rxjs';

import { EnvironmentService, ErableHttpService } from '@ecm/consumer';
import { StoreService } from '@ecm/dispatcher';

import { ContractInContractSelector } from '../business/api/contractSelector/contract-in-contract-selector';
import { ContractSelector } from '../business/api/contractSelector/contract-selector';

/**
 * Class used to extract all deprecated code from PortfolioService
 * @deprecated use PortfolioService instead
 */
export class ContractSelectorService {
    public constructor(
        private environmentService: EnvironmentService,
        private httpService: ErableHttpService,
        private pageId: string,
    ) {}

    public getFullResponse(): Observable<ContractSelector> {
        const env = this.environmentService.instant();
        return this.httpService
            .get(env.API.CONTRACT_SELECTOR_URL, {
                feature: 'navigation',
                pageId: this.pageId,
                functionality: 'CSELECTOR',
                partner: 'ZGP',
                service: 'contractSelector',
            })
            .pipe(
                map((response: any) => {
                    // set one-i eligibility
                    const ISONEI_KEY = 'isOneI';
                    const isOneI: boolean = response[ISONEI_KEY] ? response[ISONEI_KEY] : false;
                    StoreService.set('one', isOneI);
                    return <ContractSelector>response;
                }),
                catchError((error: HttpErrorResponse) => {
                    return throwError(() => error);
                }),
            );
    }

    public getDefaultContract(): Observable<ContractInContractSelector> {
        return this.getFullResponse().pipe(
            map((response: ContractSelector) => {
                if (response.contracts.length > 0) {
                    for (const contract of response.contracts) {
                        if (contract.contractId === response.defaultContractId) {
                            return contract;
                        }
                    }
                }
                return null;
            }),
        );
    }

    public getContracts(): Observable<Map<string, ContractInContractSelector>> {
        return this.getFullResponse().pipe(
            map((response: ContractSelector) => {
                const contractsMap = new Map<string, ContractInContractSelector>();
                for (const contract of response.contracts) {
                    contractsMap.set(contract.contractId, contract);
                }
                return contractsMap;
            }),
            catchError((error: HttpErrorResponse) => throwError(() => error)),
        );
    }

    public getContract(contractId: string): Observable<ContractInContractSelector> {
        return this.getContracts().pipe(
            map((contracts: Map<string, ContractInContractSelector>) => {
                return contracts.has(contractId) ? contracts.get(contractId) : null;
            }),
        );
    }
}
